
export  const orderChains = [
    {
        id: 1,
        title: "Start New Request",
        image: "/images/new-request.svg",
        url: "new-request",
        link: "ship-now"
    },
    {
        id: 2,
        title: "View Pending Orders",
        image: "/images/pending.svg",
        url: "pending-orders",
        link: "shipments"
    },
    {
        id: 3,
        title: "Top-up Wallet",
        image: "/images/top-wallet.svg",
        url: "wallet",
        link: "wallet"

    },
    {
        id: 4,
        title: "Raise a concern",
        image: "/images/open-ticket.svg",
        url: "Raise-concern",
        link: 'tickets/create-ticket'
    }
]
export const deliveryData = [
    {
        id: 1,
        title: "Pending pickup",
        name:"Pending Pick-Up",
        image: "/images/pendingPickup.svg",
        color: "#FFF3C7",

    },
    {
        id: 2,
        name:"Picked-Up",
        title: "Picked up items",
        image: "/images/pickedItem.svg",
        color: "#FFF3C7",
    },
    {
        id: 3,
        title: "Prepared for delivery",
        name:"Prepared For Delivery",
        image: "/images/preparedDelivery.svg",
        color: "#ECFFC7",
    },
    {
        id: 4,
        title: "Delivery in progress",
        name:"Delivery In Progress",
        image: "/images/preparedDelivery.svg",
        color: "#ECFFC7",
    },
   
    {
        id: 5,
        title: "Delivered items",
        name:"Delivered",
        image: "/images/DItems.svg",
        color: "#CDFFC7",
    },
    {
        id: 6,
        title: "In transit back to you",
        name:"In Transit Back to you",
        image: "/images/TransitBack.svg",
        color: "#C7F2FF",
    },

    {
        id: 7,
        title: "Returned items",
        name:"Returned",
        image: "/images/returnedItems.svg",
        color: "#C7DFFF",
    },
    
    {
        id: 8,
        title: "Total shipment",
        name:"",
        image: "/images/totalShipment.svg",
        color: "#CBC7FF",
    },
  
]
export const warehouseData = [
    {
        id: 1,
        title: "Items in Storage",
        name:"Pending Pick-Up",
        image: "/images/DItems.svg",
        color: "#B4F2AA",

    },
    {
        id: 2,
        title: "Pending Requests",
        name:"Pending Requests",
        image: "/images/home1.svg",
        color: "#FFF3C7",
    },
    {
        id: 3,
        title: "Value of Items in Storage",
        name:"Prepared For Delivery",
        image: "/images/home2.svg",
        color: "#ECFFC7",
    },
    {
        id: 4,
        title: "Items Retrieved",
        name:"Delivery In Progress",
        image: "/images/home3.svg",
        color: "#ECFFC7",
    },
]
export  const warehouseStats = [
    {
        id: 1,
        title: "Store Item in Warehouse",
        image: "/images/storeItem.svg",
        link: "store-item"
    },
    {
        id: 2,
        title: "Retrieve Item from Storage",
        image: "/images/retrieveItem.svg",
        link: "retrieve-item"
    },
    {
        id: 3,
        title: "View Order Requests",
        image: "/images/viewRequest.svg",
        link: "requests"

    },
    {
        id: 4,
        title: "View Warehouse Inventory",
        image: "/images/viewWarehouse.svg",
        link: 'view-inventory'
    }
]
